import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import TrustWealthLogo from '../TrustWealthLogo';

const navLinks = [
  { name: 'Home', path: '/' },
  { name: 'About', path: '/about' },
  { name: 'Products', path: '/products' },
  { name: 'Contact', path: '/contact' }
];

const Navigation = () => {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-[100] transition-all duration-300 ${
        isScrolled 
          ? 'bg-white/95 backdrop-blur-md shadow-card' 
          : 'bg-white/80 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo: keep normal (non-inverted) on public nav even when user has dark mode on */}
          <div className="dark:[&_img]:!invert-0 dark:[&_img]:!opacity-100">
            <TrustWealthLogo />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className={`px-3 py-2 text-sm font-medium rounded-xl transition-all duration-200
                  hover:bg-primary-50 relative group ${
                  location.pathname === link.path 
                    ? 'text-primary-700 bg-primary-50' 
                    : 'text-gray-600 hover:text-primary-700'
                }`}
              >
                {link.name}
                {location.pathname === link.path && (
                  <span className="absolute bottom-1.5 left-3 right-3 h-0.5 bg-primary-600 rounded-full" />
                )}
              </Link>
            ))}
            <div className="flex items-center space-x-2 ml-4">
              <Link
                to="/login"
                className="px-4 py-2 text-sm font-medium text-primary-600 hover:text-primary-700 
                  hover:bg-primary-50 rounded-xl transition-all duration-200"
              >
                Sign In
              </Link>
              <Link
                to="/signup"
                className="px-4 py-2 text-sm font-medium text-white 
                  bg-gradient-to-r from-primary-600 to-primary-700
                  hover:from-primary-700 hover:to-primary-800
                  shadow-sm hover:shadow-md
                  transition-all duration-300 
                  hover:-translate-y-0.5 rounded-xl"
              >
                Open Account
              </Link>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden inline-flex items-center justify-center p-2 rounded-xl text-gray-600 hover:text-primary-600 hover:bg-primary-50 transition-colors duration-200"
          >
            <span className="sr-only">Open main menu</span>
            {!isMobileMenuOpen ? (
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            ) : (
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden absolute top-16 inset-x-0 bg-white/95 backdrop-blur-md shadow-card transition-all duration-300 ease-in-out ${
          isMobileMenuOpen ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4 pointer-events-none'
        }`}
      >
        <div className="px-4 pt-2 pb-3 space-y-1">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.path}
              className={`block px-4 py-3 text-base font-medium rounded-xl transition-all duration-200 ${
                location.pathname === link.path
                  ? 'text-primary-700 bg-primary-50'
                  : 'text-gray-600 hover:text-primary-700 hover:bg-primary-50'
              }`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {link.name}
            </Link>
          ))}
          <div className="pt-4 space-y-2">
            <Link
              to="/login"
              className="block w-full px-4 py-3 text-base font-medium text-primary-600 hover:text-primary-700 
                hover:bg-primary-50 rounded-xl transition-all duration-200"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Sign In
            </Link>
            <Link
              to="/signup"
              className="block w-full px-4 py-3 text-base font-medium text-white bg-gradient-to-r 
                from-primary-600 to-primary-700 rounded-xl"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Open Account
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation; 